import { useState, useCallback } from 'react';
import { ApiError, ErrorState } from '../types/errors';
import { logError } from '../utils/errorUtils';

export function useError() {
  const [errorState, setErrorState] = useState<ErrorState>({
    visible: false,
    error: null,
    timestamp: 0,
  });

  const showError = useCallback((error: ApiError) => {
    logError(error);
    setErrorState({
      visible: true,
      error,
      timestamp: Date.now(),
    });
  }, []);

  const clearError = useCallback(() => {
    setErrorState({
      visible: false,
      error: null,
      timestamp: Date.now(),
    });
  }, []);

  return {
    errorState,
    showError,
    clearError,
  };
}
